import React from "react";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";

import {
  divVariants,
  fadeVariants,
  slideVariants,
  bounce_right_to_left_variants
} from "shared/components/animations";
import UsersList from "./UsersList";
import ProgressBar from "./ProgressBar";

const LiarGuessing = ({
  users,
  ttl_lie,
  mobile_app,
  ttl_truths,
  ttl_users_list,
  guessing_params
}) => {
  const title = _.get(guessing_params, "title", "Let’s see that poker face!");
  const lie_text = _.get(guessing_params, "lie_text", "The Lie:");
  const truth_text = _.get(guessing_params, "truth_text", "The Truths:");
  const results_text = _.get(guessing_params, "results_text", "Results:");

  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className={`ttl-poker ${mobile_app ? "mobile-cnt" : "web-cnt"}`}
    >
      <motion.h2 variants={fadeVariants} className="ttl-primary-text">
        {title}
      </motion.h2>

      <motion.div
        variants={bounce_right_to_left_variants}
        className="lie-container"
      >
        <h2 className="lie-heading">{lie_text}</h2>
        <p className="lie-text">{`A) ${ttl_lie}`}</p>
        <UsersList userArray={ttl_users_list.lie} />
      </motion.div>

      <motion.div
        variants={bounce_right_to_left_variants}
        className="truth-container"
      >
        <h2 className="truth-heading">{truth_text}</h2>
        <div className="all-truths">
          <p className="lie-text">{`B) ${ttl_truths[0]}`}</p>
          <UsersList userArray={ttl_users_list.truth_1} />
        </div>
        <div className="spacing-div" />
        <div className="all-truths">
          <p className="lie-text">{`C) ${ttl_truths[1]}`}</p>
          <UsersList userArray={ttl_users_list.truth_2} />
        </div>
      </motion.div>

      <motion.div variants={slideVariants} className="result-container">
        <p className="result-text">{results_text}</p>
        <ProgressBar
          chunkSize={100 / (users.length - 1)}
          lieCount={ttl_users_list.lie.length}
          truthCount={
            ttl_users_list.truth_1.length + ttl_users_list.truth_2.length
          }
        />
      </motion.div>
    </motion.div>
  );
};

export default LiarGuessing;
